import { Serializable } from '../../../core/models/serializable';
import { PortfolioAccountManagerModel } from './portfolio-account-manager-model';

export class PortfolioModel implements Serializable<PortfolioModel> {
  fromObject(object: any): PortfolioModel {
    Object.assign(this, object);

    this.currentAccountManager = null;

    if (object.currentAccountManager != null) {
      let t = new PortfolioAccountManagerModel();
      t = t.fromObject(object.currentAccountManager);
      this.currentAccountManager = t;
    }

    return this;
  }

  toObject() {
    var result = {
      PortfolioId: this.portfolioId,
      CurrentAccountManager: this.currentAccountManager,
      Name: this.name,
      Comment: this.comment,
      LastModifiedDate: this.lastModifiedDate,
      IsDeleted: this.isDeleted,
      CreateDate: this.createDate,
      LastModifiedUser: this.lastModifiedUser,
      CreateUser: this.createUser,
    };
    return result;
  }

  public portfolioId: number;
  public name: string;
  public comment: string;
  public createDate: Date;
  public isDeleted: boolean;
  public lastModifiedDate: Date;
  public currentAccountManager: PortfolioAccountManagerModel;
  public lastModifiedUser: UserModel;
  public createUser: UserModel;

  constructor() {
    this.currentAccountManager = new PortfolioAccountManagerModel();
    this.lastModifiedUser = new UserModel();
  }
}

export class UserModel {
  public UserId: number;
}
